module.exports = __webpack_public_path__ + "media/honey-icons/icon-deliver-d34aa3f8.svg";